import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { PersonalInfoService } from '../../../shared/services/personal-info.service';

@Component({
  selector: 'app-security-question',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './security-question.component.html',
  styleUrl: './security-question.component.scss',
})
export class SecurityQuestionComponent implements OnInit {
  @ViewChild('errorElement') errorElement!: ElementRef;
  questionnaireForm!: FormGroup;
  questions: any[] = [];
  currentQuestionIndex: number = 0;
  errorMessage: string | undefined;
  customError: boolean = false;

  constructor(
    private _fb: FormBuilder,
    private _router: Router,
    private _personalInfo: PersonalInfoService,
  ) {}

  ngOnInit(): void {
    this.questionnaireForm = new FormGroup({});
    const res = history?.state;
    this.loadQuestions(res);
  }

  // convenience getter for easy access to form fields
  get form() {
    return this.questionnaireForm.controls;
  }

  loadQuestions(res: any) {
    const response: any = res;

    this.questions = response?.securityQA?.qA?.questions;
    this.questions?.forEach((q) => {
      this.questionnaireForm?.addControl(q?.key?.toString(), this._fb?.control('', Validators.required));
    });
  }

  onNext() {
    const currentQuestionKey = this.questions[this.currentQuestionIndex]?.key;
    if (this.questionnaireForm.get(currentQuestionKey)?.invalid) {
      setTimeout(() => {
        this.errorElement?.nativeElement?.focus();
      }, 0.1);
      this.customError = true;
      this.errorMessage = 'Please select an answer before proceeding.';
      return;
    }
    if (this.currentQuestionIndex < this.questions.length - 1) {
      this.customError = false;
      this.currentQuestionIndex++;
      this.errorMessage = '';
    }
  }

  onBack() {
    this.errorMessage = '';
    if (this.currentQuestionIndex > 0) {
      this.currentQuestionIndex--;
    }
  }

  onSubmit() {
    if (this.questionnaireForm.valid) {
      const answers = this.questions.map((q) => ({
        key: q.key,
        option: this.questionnaireForm.get(q.key.toString())?.value,
      }));
      const payload = {
        requestingSystem: 'FinPro',
        userAnswers: answers,
      };
      this._personalInfo.ValidateSecurityAnswer(payload).subscribe((response) => {
        if (response.action === 'Success') {
          this._router.navigate(['/advisor/mfa']);
        } else {
          this._router.navigate(['/user-profile/call-us']);
        }
      });
    } else {
      this.customError = true;
      this.errorMessage = 'Please select an answer before proceeding.';
    }
  }
}
